/* eslint-disable no-restricted-syntax */
import React from "react";
import ItemList from "./ItemList";
import commonUtil from "../../../utils/commonUtil";

export default ({ category, id }) => {
  const handleToggle = (element) => {
    const isOpen = element.ariaExpanded === "true";
    const content = element.nextElementSibling;
    const text = content.querySelector("p");
    const headers = document.querySelectorAll("article button");
    for (const header of headers) {
      header.classList.remove("active");
      header.nextElementSibling.style.height = "0px";
      header.ariaExpanded = header.id === element.id ? `${!isOpen}` : "false";
    }
    if (!isOpen) {
      element.classList.add("active");
      content.style.height = `${text.clientHeight}px`;
    }
  };
  return (
    <div className="containerStyleFAQ boxStyleFAQ">
      <div className="headerStyleFAQ">
        <img
          src={
            commonUtil.getAssetURL() +
            `/images/faqs/mr/${commonUtil
              .convertSpanishToEnglishChars(category?.category)
              ?.toLowerCase()
              ?.replaceAll(" ", "_")}.png`
          }
          alt="iconFAQ"
          width="56"
          height="56"
        />
        <p className="fontTitleStyleFAQ">{category.category}</p>
      </div>
      {category &&
        category.questions.map((question, index) => (
          <ItemList
            key={index}
            id={index}
            categoryID={id}
            handleToggle={handleToggle}
            faq={{
              header: question.question,
              text: question.answers[0].answer,
            }}
          />
        ))}
    </div>
  );
};
